import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classNames from 'classnames';
import { debounce } from 'lodash';
import React, { useCallback, useContext, useState } from 'react';
import { HeaderStateContext } from '../../../context/header-state-context';
import { useHeaderData } from '../../../hooks/use-header-data';
import { WhatsNewSection } from '../../whats-new/whats-new-section';
import { getSideBarItems } from '../helpers/flatten-side-bar-groups';
import Sidebar from './sidebar';
import { SidebarHeader } from './sidebar-header';
import styles from './sidebar.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SecondLevel = function SecondLevel(_ref) {
  var sideBarGroups = _ref.sideBarGroups,
      showWhatsNew = _ref.showWhatsNew;
  return /*#__PURE__*/_jsxs("ul", {
    role: "menu",
    className: classNames('d-flex flex-column gap-300 py-400'),
    children: [getSideBarItems({
      items: sideBarGroups,
      isAnimated: false
    }), /*#__PURE__*/_jsx(WhatsNewSection, {
      hidden: !showWhatsNew
    })]
  });
};

export var SecondLevelSidebar = function SecondLevelSidebar(_ref2) {
  var _headerData$productNa;

  var title = _ref2.title,
      sideBarGroups = _ref2.sideBarGroups,
      showFirstLevel = _ref2.showFirstLevel;
  var headerData = useHeaderData();

  var _useContext = useContext(HeaderStateContext),
      resetNavBarState = _useContext.resetNavBarState,
      closeNavDrawer = _useContext.closeNavDrawer;

  var _useState = useState(false),
      showShadow = _useState[0],
      setShowShadow = _useState[1];

  var debouncedSetShowShadow = debounce(setShowShadow, 250, {
    leading: true
  });
  var handleOnScroll = useCallback(function (shouldShowShadow) {
    return debouncedSetShowShadow(shouldShowShadow);
  }, [debouncedSetShowShadow]);
  return /*#__PURE__*/_jsxs(Sidebar, {
    isSideBarOpen: !showFirstLevel,
    className: styles.itemSlide,
    children: [/*#__PURE__*/_jsx(SidebarHeader, {
      withBackButton: !showFirstLevel,
      onBackButtonClick: resetNavBarState,
      onCloseClick: closeNavDrawer,
      showShadow: showShadow,
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: classNames(styles.sidebarBody, _defineProperty({}, styles.open, !showFirstLevel), 'px-300 h-100 d-flex flex-column'),
      onScroll: function onScroll(event) {
        var target = event.target;
        handleOnScroll(target.scrollTop !== 0);
      },
      children: /*#__PURE__*/_jsx(SecondLevel, {
        sideBarGroups: sideBarGroups,
        showWhatsNew: title === (headerData === null || headerData === void 0 ? void 0 : (_headerData$productNa = headerData.productNavigation) === null || _headerData$productNa === void 0 ? void 0 : _headerData$productNa.title)
      })
    })]
  });
};